import { ChangeDriverInput, ReceiveTripOutput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

const assignDriverToTrip = (tripKey: string, input: ChangeDriverInput) =>
  driverApi.post<ChangeDriverInput, ReceiveTripOutput>(`/trip/v1/${tripKey}/change-driver`, input);

export const useAssignDriverToTrip = (tripKey: string) =>
  useMutation<ReceiveTripOutput, unknown, ChangeDriverInput>({
    mutationFn: input => assignDriverToTrip(tripKey, input),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.user.fetchTrips());
    },
  });
